function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState, useMemo, forwardRef } from "react";
import { getRemoteComponent } from "../../globalScriptProviders";
import { SkeletonLoader } from "../utilities/SkeletonLoader";
import logger from "../../logger";
var RemoteComponent = /*#__PURE__*/ forwardRef(function RemoteComponent(props, ref) {
    var _props_children = props.children, children = _props_children === void 0 ? null : _props_children, component = props.component, _props_remote = props.remote, remote = _props_remote === void 0 ? "abtests" : _props_remote, tmp = props.props, overrideProps = tmp === void 0 ? {} : tmp;
    var fallback = useMemo(function() {
        return children;
    }, [
        children
    ]);
    var _useState = _sliced_to_array(useState(), 2), FederatedSuspenseComponent = _useState[0], setFederatedSuspenseComponent = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), remoteError = _useState1[0], setRemoteError = _useState1[1];
    useEffect(function() {
        var cancelled = false;
        var awaitRemoteComponent = /*#__PURE__*/ _async_to_generator(function() {
            var _result, _ref, remoteComponent, factory, result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(cancelled === false)) return [
                            3,
                            6
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            getRemoteComponent({
                                remote: remote,
                                component: component
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), remoteComponent = _ref.component;
                        return [
                            4,
                            remoteComponent
                        ];
                    case 3:
                        factory = _state.sent();
                        return [
                            4,
                            factory()
                        ];
                    case 4:
                        result = _state.sent();
                        if (!((_result = result) == null ? void 0 : _result.default)) {
                            throw new Error("Missing default export");
                        }
                        setFederatedSuspenseComponent(function() {
                            return result.default;
                        });
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        logger.warn("RemoteComponent " + remote + "(" + component + ")", error);
                        setRemoteError(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        // Execute async without awaiting to allow thread to continue
        awaitRemoteComponent();
        return function() {
            cancelled = true;
        };
    }, [
        component,
        remote
    ]);
    if (remoteError) {
        return fallback;
    }
    if (!FederatedSuspenseComponent) {
        return /*#__PURE__*/ _jsx(SkeletonLoader, {
            children: fallback
        });
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        ref: ref,
        fallback: /*#__PURE__*/ _jsx(SkeletonLoader, {
            children: fallback
        }),
        children: /*#__PURE__*/ _jsx(FederatedSuspenseComponent, _extends({}, overrideProps, {
            ref: ref,
            children: children
        }))
    });
});
RemoteComponent.displayName = "RemoteComponent";
// eslint-disable-next-line  react/display-name
var withRemoteComponent = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ _jsx(RemoteComponent, _extends({}, props, {
            children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props))
        }));
    };
};
export { withRemoteComponent, RemoteComponent };

//# sourceMappingURL=index.js.map